module.exports = __webpack_public_path__ + "img/type4.28b0d459.png";